export default __webpack_public_path__ + "images/d046436a65b1820ddd548902ba3ff77c.svg";